export function initToastTesting() {
	const toast = document.querySelector('.toast-testing');
	if (!toast)
		return;

	const toastClose = toast.querySelector('.toast-testing__close');
	if (!toastClose)
		return;

	const showToastTesting = localStorage.getItem('show-toast-testing');
	if (showToastTesting && showToastTesting === 'N')
		return toast.style.display = 'none';

	toastClose.addEventListener('click', () => {
		toast.style.display = 'none';
		localStorage.setItem('show-toast-testing', 'N');
	});
}



// WEBPACK FOOTER //
// ./src/js/toast-testing.js